import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mainLineConfig } from "./data";

export default function MainLinePage() {
  return <CityPageTemplate config={mainLineConfig} />;
}